import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-start mb-7"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "fs-7 position-absolute w-100 text-muted",
  style: {"line-height":"1.6"}
}, null, -1)
const _hoisted_3 = {
  class: "el-upload-list__item is-success",
  tabindex: "0"
}
const _hoisted_4 = { class: "el-upload-list__item-name" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-close-tip" }, "press delete to remove", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_upload = _resolveComponent("el-upload")

  return (_openBlock(), _createBlock(_component_el_upload, {
    ref: "upload",
    action: "#",
    disabled: _ctx.disabled,
    class: _ctx.$attrs.class,
    style: _ctx.$attrs.style,
    "auto-upload": _ctx.autoUpload,
    multiple: _ctx.multiple,
    limit: !_ctx.multiple ? 1 : _ctx.limit,
    "file-list": _ctx.internalFileList,
    "http-request": _ctx.uploadHTTPRequestFunction,
    "before-upload": _ctx.handleBeforeUpload,
    "on-success": _ctx.clear,
    onChange: _ctx.updateFileList,
    onRemove: _ctx.handleRemove,
    onError: _ctx.onError,
    onProgress: _ctx.onUploading,
    onSuccess: _ctx.onSuccess
  }, _createSlots({
    default: _withCtx(() => [
      (!_ctx.showHints)
        ? (_openBlock(), _createBlock(_component_base_button, {
            key: 0,
            disabled: _ctx.disabled,
            size: "small",
            type: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.showHints)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_base_button, {
              disabled: _ctx.disabled,
              size: "small",
              type: "default"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _hoisted_2
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (!_ctx.multiple || _ctx.limit === 1)
      ? {
          name: "file",
          fn: _withCtx(({ file }) => [
            _createVNode("li", _hoisted_3, [
              _createVNode("a", _hoisted_4, [
                _hoisted_5,
                _createVNode("span", null, _toDisplayString(file.name), 1)
              ]),
              _createVNode("i", {
                class: "el-icon-close",
                onClick: ($event: any) => (_ctx.cleanupFileList(file))
              }, null, 8, ["onClick"]),
              _hoisted_6,
              (file.status === 'uploading')
                ? (_openBlock(), _createBlock(_component_el_progress, {
                    key: 0,
                    type: _ctx.line,
                    "stroke-width": 2,
                    percentage: +file.percentage
                  }, null, 8, ["type", "percentage"]))
                : _createCommentVNode("", true)
            ])
          ])
        }
      : undefined
  ]), 1032, ["disabled", "class", "style", "auto-upload", "multiple", "limit", "file-list", "http-request", "before-upload", "on-success", "onChange", "onRemove", "onError", "onProgress", "onSuccess"]))
}